import axiosInstance from '../axiosConfigPayment';

export default {
  async getHtmlEvo(payload) {
    const response = await axiosInstance.post('Paso1', payload);
    return response.data;
  },
  async getEvoSessionId(payload) {
    const response = await axiosInstance.post('ObtenerSessionId', payload);
    return response.data;
  },
  async getPaymentStatus(firma) {
    const response = await axiosInstance.get(`GetStatusPago?Firma=${firma}`);
    return response.data;
  },
};
